import React from 'react';
import { Card, CardContent, Typography, Box, Grid, Divider, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { LicitacaoList } from '../licitacao/types/Licitacao';
import configSiteUrls from '../../configs/configSiteUrls';

interface LicitacaoCardProps {
  licitacoes: LicitacaoList[];
  isFetching?: boolean;
}

export default function LicitacaoHomeCardForm({ licitacoes, isFetching }: LicitacaoCardProps) {
  const navigate = useNavigate();

  const logoLicitacao = { imagem: '/images/logolicitacaocamaravirginia.png', alt: 'Acesso a licitações e compras', link: configSiteUrls.SITE_LICITACAO_PUBLIC_LIST };

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(configSiteUrls.SITE_LICITACAO_PUBLIC_LIST);
  };

  if (isFetching) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="textSecondary">Carregando últimas licitações...</Typography>
      </Box>
    );
  }

  if (!licitacoes || licitacoes.length === 0) {
    return  <Typography variant="body2" color="textSecondary">Erro: Licitações não carregadas!</Typography>;
  }

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography
          color="primary"
          sx={{
            fontWeight: 700,
            fontSize: { xs: '20px', sm: '24px', md: '28px' }, // aumento significativo
            lineHeight: { xs: '26px', sm: '30px', md: '34px' }, // proporcional ao tamanho da fonte
            mt: 1
          }}
        >
          Compras e Licitações
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {licitacoes.map(licitacao => (
          <Grid
            item
            key={licitacao.id}
            xs={12} // Mobile: ocupa toda largura
            sm={6} // Tablet: ocupa metade
            md={4} // Desktop: 3 cards por linha
          >
            <Card sx={{ width: '100%' }}>
              <a href="#" onClick={e => handleClick(e)} style={{ textDecoration: 'none', color: 'inherit' }}>
                <CardContent sx={{ p: 1 }}>
                  <Box
                    component="img"
                    src={logoLicitacao.imagem}
                    alt={logoLicitacao.alt}
                    sx={{
                      width: '100%',
                      height: { xs: '200px', sm: '180px', md: '200px' },
                      borderRadius: 2,
                      objectFit: 'cotain'
                    }}
                  />
                  <Box sx={{ mb: 1 }}>
                    <Typography variant="caption" color="secondary" sx={{ fontWeight: 500 }}>
                      Modalidade: {licitacao?.modalidade.nome || 'N/A'}
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 1 }}>
                    <Divider sx={{ borderColor: '#EBEBEB' }} />
                  </Box>

                  {/* Linha 2: Observação */}
                  <Box sx={{ mt: 1, flexGrow: 1 }}>
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontWeight: 400,
                        fontSize: { xs: '13px', sm: '14px', md: '15px' },
                        lineHeight: { xs: '18px', sm: '20px', md: '22px' },
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 4, // limita a 4 linhas
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-word'
                      }}
                    >
                      {licitacao.objeto}
                    </Typography>
                  </Box>

                  <Typography variant="caption" color="secondary" sx={{ textAlign: 'right', display: 'block' }}>
                    {licitacao?.dataHoraCriacao ? new Date(licitacao?.dataHoraCriacao).toLocaleDateString() : ''}
                  </Typography>
                </CardContent>
              </a>
            </Card>
          </Grid>
        ))}
      </Grid>
    </>
  );
}
